module.exports = __webpack_public_path__ + "img/savecardactive.74b43cee.png";